export default "__VITE_ASSET__ByPDg0U9__"